module.exports = __webpack_public_path__ + "img/FHWP_dark_sword.d9d0dabc.png";